/* src/app/shared/components/pbi-loader/pbi-loader.component.scss */
* {
  border: 0;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
:root {
  --hue: 223;
  --bg: hsl(var(--hue),90%,25%);
  --fg: hsl(var(--hue),10%,90%);
  --trans-dur: 0.3s;
}
.pbiLoaderWrapper {
  background: var(--bg);
  color: var(--fg);
  font: 1em/1.5 sans-serif;
  display: grid;
  place-items: center;
}
.pl {
  display: block;
  width: 200px;
  height: 200px;
  margin-top: -180px;
}
.pbiLoaderImagewrapper {
  margin-top: 120px;
  width: 150px;
  height: 150px;
}
.pbiLoaderImage {
  max-width: 125px;
  max-height: 125px;
}
#wrapper td {
  vertical-align: middle;
  text-align: center;
}
.pl__ring-rotate,
.pl__ring-stroke {
  animation-duration: 3.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.pl__ring-rotate,
.pl__ring-stroke {
  transform-origin: 80px 80px;
}
.pl__ring-rotate {
  animation-name: ringRotate;
}
.pl__ring-stroke {
  animation-name: ringStroke;
  transform: rotate(-45deg);
}
@keyframes ringRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(720deg);
  }
}
@keyframes ringStroke {
  from, to {
    stroke-dashoffset: 452;
    transform: rotate(-45deg);
  }
  50% {
    stroke-dashoffset: 169.5;
    transform: rotate(-180deg);
  }
}
/*# sourceMappingURL=pbi-loader.component-MLZTYQIV.css.map */
